import React, { useContext, useCallback } from 'react';

import api, { Pergunta } from 'api/DuvidasFrequentes';

import { List, ListItem, ListItemText, Typography } from '@material-ui/core';
import Context from 'components/__ASSOCIADO__/DuvidasFrequentes/Context';

import useDuvidasStyles from './style';
import { ChatAlertIcon } from 'components/Icons';

export default function Duvidas() {
  const classes = useDuvidasStyles();
  const {
    perguntas,
    atualizarPergunta,
    isPerguntaUsuario,
    isPerguntaNaoLida,
    isPerguntaAdmin,
    ocultarNomeChat,
    cooperativa,
    destaque,
  } = useContext(Context);

  const marcarComoLido = useCallback(
    (pergunta: Pergunta) => {
      return async () => {
        if (isPerguntaUsuario(pergunta) && isPerguntaNaoLida(pergunta)) {
          const { response } = await api.lido(pergunta.idDuvidaFrequente);
          if (response && response.status === 200) {
            atualizarPergunta({
              ...pergunta,
              lido: true,
            });
          }
        }
      };
    },
    [isPerguntaUsuario, isPerguntaNaoLida, atualizarPergunta]
  );

  return (
    <List className={classes.list} id='duvidas-lista'>
      {(perguntas || [])
        .sort(
          (a, b) =>
            new Date(b.dataDuvida).getTime() - new Date(a.dataDuvida).getTime()
        )
        .map((question: Pergunta) => {
          let precisaOcultarNome =
            !isPerguntaAdmin(question) &&
            ocultarNomeChat &&
            !isPerguntaUsuario(question);
          let itemClassName = [
            classes.item,
            isPerguntaAdmin(question) ? classes.itemAdmin : undefined,
            destaque === question.idDuvidaFrequente
              ? classes.itemDestque
              : undefined,
          ];
          let nameClassName = [
            isPerguntaAdmin(question) ? classes.itemTextDestaque : '',
            precisaOcultarNome ? classes.hideName : '',
          ];
          return (
            <ListItem
              key={question.idDuvidaFrequente}
              id={`duvida-${question.idDuvidaFrequente}`}
              component='li'
              className={itemClassName
                .filter((c) => c !== undefined)
                .join(' ')
                .trim()}
              onFocus={marcarComoLido(question)}
              tabIndex={1}
              disableGutters
              button
            >
              <ListItemText
                disableTypography
                className={classes.itemText}
                primary={
                  <>
                    <Typography component='p'>
                      {isPerguntaUsuario(question) &&
                        isPerguntaNaoLida(question) && (
                          <span className={classes.notify} />
                        )}
                      {question.resposta && (
                        <ChatAlertIcon
                          color={'#3FA110'}
                          style={{
                            marginRight: '4px',
                            fontSize: '24px',
                            marginTop: '3px',
                          }}
                        />
                      )}
                      <strong className={nameClassName.join(' ').trim()}>
                        {isPerguntaAdmin(question)
                          ? cooperativa // translation.DuvidasFrequentes.assessorLabel
                          : (precisaOcultarNome
                              ? ''
                              : question.usuarioDuvida || ''
                            ).toLowerCase()}
                      </strong>
                      {question.duvida}
                    </Typography>
                  </>
                }
                secondary={
                  question.resposta ? (
                    <Typography component='p' className={classes.itemResposta}>
                      <strong className={classes.itemTextDestaque}>
                        {cooperativa}
                      </strong>
                      {question.resposta}
                    </Typography>
                  ) : undefined
                }
              />
            </ListItem>
          );
        })}
    </List>
  );
}
